"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareDatetimeOriginTransformations = compareDatetimeOriginTransformations;
exports.datetimeTransformationLabels = exports.orderedDatetimeTransformations = exports.orderedDateTransformations = exports.DatetimeOriginTransformation = void 0;

var _datetimeTransformati;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatetimeOriginTransformation;
exports.DatetimeOriginTransformation = DatetimeOriginTransformation;

(function (DatetimeOriginTransformation) {
  DatetimeOriginTransformation["MINUTE"] = "minute";
  DatetimeOriginTransformation["HOUR"] = "hour";
  DatetimeOriginTransformation["DAY"] = "day";
  DatetimeOriginTransformation["WEEK"] = "week";
  DatetimeOriginTransformation["MONTH"] = "month";
  DatetimeOriginTransformation["QUARTER"] = "quarter";
  DatetimeOriginTransformation["YEAR"] = "year";
})(DatetimeOriginTransformation || (exports.DatetimeOriginTransformation = DatetimeOriginTransformation = {}));

var orderedDateTransformations = [DatetimeOriginTransformation.DAY, DatetimeOriginTransformation.WEEK, DatetimeOriginTransformation.MONTH, DatetimeOriginTransformation.QUARTER, DatetimeOriginTransformation.YEAR];
exports.orderedDateTransformations = orderedDateTransformations;
var orderedDatetimeTransformations = [DatetimeOriginTransformation.MINUTE, DatetimeOriginTransformation.HOUR].concat(orderedDateTransformations);
exports.orderedDatetimeTransformations = orderedDatetimeTransformations;
var datetimeTransformationLabels = (_datetimeTransformati = {}, _defineProperty(_datetimeTransformati, DatetimeOriginTransformation.MINUTE, 'Minute'), _defineProperty(_datetimeTransformati, DatetimeOriginTransformation.HOUR, 'Hour'), _defineProperty(_datetimeTransformati, DatetimeOriginTransformation.DAY, 'Day'), _defineProperty(_datetimeTransformati, DatetimeOriginTransformation.WEEK, 'Week'), _defineProperty(_datetimeTransformati, DatetimeOriginTransformation.MONTH, 'Month'), _defineProperty(_datetimeTransformati, DatetimeOriginTransformation.QUARTER, 'Quarter'), _defineProperty(_datetimeTransformati, DatetimeOriginTransformation.YEAR, 'Year'), _datetimeTransformati);
/**
 *
 * @returns 0 if t1 equals t2
 * -1 if t1 is smaller than t2
 * 1 if t1 is larger than t2
 */

exports.datetimeTransformationLabels = datetimeTransformationLabels;

function compareDatetimeOriginTransformations(t1, t2) {
  if (t1 === t2) return 0;
  var t1Size = orderedDatetimeTransformations.indexOf(t1);
  var t2Size = orderedDatetimeTransformations.indexOf(t2);

  if (t1Size === -1 || t2Size === -1) {
    throw new Error('Property origin tranformation does not exist in orderedDatetimeTransformations');
  }

  return t1Size < t2Size ? -1 : 1;
}